<div class="d-flex align-items-center">
  <div>
    <div
      class="__icon-wrapper"
      [style.background-color]="iconBgColor()"
      [ngbTooltip]="tooltipText()"
      container="body"
      placement="top"
    >
      <span class="__icon {{ icon() }}"></span>
    </div>
  </div>
  <div class="__description rmv-flex-1">
    <ng-content></ng-content>
  </div>
</div>